<i class="chat-avatar-img" [ngClass]="getClassIcon()" aria-hidden="true"></i>